import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import useCommentHistoryData from 'hooks/tableData/useCommentHistoryData';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import Popup from 'components/popup/popup';
import UploadDisplay from 'components/uploadFile/UploadDisplay';
import LoadingIndicator from 'components/LoadingIndicator';
import { Grid } from '@material-ui/core';
import api from 'api/call';

const SLayout = styled.div`
    padding: 10px;
`;

const CommentSheet = ({ applicationDetail }) => {
    const formId = applicationDetail?.applicationForm?.id;
    const [isLoadingHistory, setLoadingHistory] = useState(true);

    const { rows, columns, isShow, setIsShow, setSelectedRow, selectedRow, isLoading, setRows } = useCommentHistoryData(
        { formId },
    );

    const confirm = () => {
        setIsShow(false);
        setSelectedRow(null);
    };

    useEffect(() => {
        api.application
            .getComment({ id: formId })
            .then((res) => {
                setRows(res.data.result);
            })
            .finally(() => {
                setLoadingHistory(false);
            });
        // .finally(() => setIsLoadingHistory(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SLayout>
            <TextHeader underline> Comment History</TextHeader>

            <div style={{ marginTop: 20 }}>
                {isLoadingHistory ? (
                    <Grid container alignItems="center" justify="center" style={{ height: '100px' }}>
                        <LoadingIndicator /> <div style={{ marginLeft: 10 }}>Loading Comments...</div>
                    </Grid>
                ) : (
                    <CustomTable
                        skipMaxHeight
                        fullWidthTable={false}
                        showAlternativeBackground
                        rows={rows}
                        columns={columns}
                    />
                )}
            </div>
            <Popup
                height="60%"
                width="60%"
                title="View Attachments"
                open={isShow}
                footerActions={[{ label: 'Close', clicked: confirm }]}
                closePopup={confirm}
                isLoading={isLoading}
            >
                <UploadDisplay
                    fileList={(selectedRow?.files ?? []).map((item) => {
                        return { name: item.fileName, downloadId: item.id };
                    })}
                    enableDownload
                    downloadType={'common'}
                />
            </Popup>
        </SLayout>
    );
};

export default CommentSheet;
